import { render, staticRenderFns } from "./chapterSortEdit.vue?vue&type=template&id=7c5ef852&scoped=true"
import script from "./chapterSortEdit.vue?vue&type=script&lang=js"
export * from "./chapterSortEdit.vue?vue&type=script&lang=js"
import style0 from "./chapterSortEdit.vue?vue&type=style&index=0&id=7c5ef852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5ef852",
  null
  
)

export default component.exports